/* @ngInject */
function RememberPasswordController (
  $scope,
  $q,
  $timeout,
  $translate,
  $location,
  ConnectorWebService,
  BackendErrorParserService,
  CONSTANTS,
  ValidationService,
  AuthService,
  ToastService,
  Utils
) {
  const getCustomMessageDialogController = () =>
    $q.when(import('../../../core/dialogs/custom-message/custom-message-dialog.controller'))

  var sHost = $location.host()
  $scope.subdomain = ''
  $scope.sCustomerLogoPath = ''
  $scope.backgroundImageUrl = ''
  $scope.backgroundUrl = ''
  $scope.emailRememberPassword = ''
  $scope.flags = {
    loadingLogo: true,
    loadingBackground: true
  }

  const api = {
    getCustomMessageDialogController
  }
  this.getApi = () => api

  activate()

  function activate () {
    AuthService.setContainerPosition()
    AuthService.getCustomerImages(sHost).then(url => {
      $scope.subdomain = localStorage.getItem('companySubdomain')
      $scope.sCustomerLogoPath = url.logo
      $scope.backgroundUrl = url.background
    })
  }

  $scope.onLogoLoad = function () {
    $timeout(() => {
      $scope.flags.loadingLogo = false
    })
  }

  $scope.onBackgroundLoad = function () {
    $timeout(() => {
      $scope.backgroundImageUrl = $scope.backgroundUrl
      $scope.flags.loadingBackground = false
    })
  }

  $scope.onEmailChange = function (evt) {
    $scope.emailRememberPassword = evt.detail.value
  }

  $scope.sendRememberPasswordEmail = function () {
    if (!$scope.emailRememberPassword) {
      return
    }

    if (!ValidationService.validateEmail($scope.emailRememberPassword)) {
      ToastService.showErrorToast($translate.instant('invalidEmail'))
      return
    }

    $scope.recoverBtnLoading = true
    ConnectorWebService.post(CONSTANTS.URL_AUTH_RECOVER, {
      email: $scope.emailRememberPassword
    }).then(
      function () {
        $scope.recoverBtnLoading = false
        ToastService.showSuccessToast($translate.instant('weSentEmailChangePasswordInstructMsg'))
      },
      function (error) {
        $scope.recoverBtnLoading = false

        if (BackendErrorParserService.isRateLimitError(error)) {
          const retryAfterHeader = error.headers('retry-after')

          if (retryAfterHeader) {
            const retryAfterMinutes = Utils.convertSecondsToMinutes(retryAfterHeader)
            const toastText = $translate.instant('tooManyRequests', { retryAfterMinutes })

            ToastService.showErrorToast(toastText)
          }
        }
      }
    )
  }
}

export { RememberPasswordController }
